module.exports = __webpack_public_path__ + "static/media/graph.7265ae38.svg";